import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// pages
import Home from './pages/Home'
import landingPage from './pages/LandingPage'
import ProfileCreator from './pages/ProfileCreator'
import ProfileUser from './pages/ProfileUser'
import Settings from './pages/Settings'
import Search from './pages/Search'
import ThirdPartySoftware from './pages/ThirdPartySoftware'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Support from './pages/Support'
import Version from './pages/Version'

export default new Router({
	routes: 
	[
		{
			path: '/landing',
			name: 'landingPage',
			component: landingPage
		},
		{
			path: '/',
			name: 'home',
			component: Home, 
		},
		{
			path: '/ProfileCreator/:id',
			name: 'ProfileCreator',
			component: ProfileCreator,
		},
		{
			path: '/ProfileUser',
			name: 'ProfileUser',
			component: ProfileUser,
		},
		{
			path: '/Settings',
			name: 'Settings',
			component: Settings,
		},
		{
			path: '/Search',
			name: 'Search',
			component: Search,
		},
		{
			path: '/ThirdPartySoftware',
			name: 'ThirdPartySoftware',
			component: ThirdPartySoftware,
		},
		{
			path: '/Terms',
			name: 'Terms',
			component: Terms,
		},
		{
			path: '/Privacy',
			name: 'Privacy',
			component: Privacy,
		},
		{
			path: '/Support',
			name: 'Support',
			component: Support,
		},
		{
			path: '/Version',
			name: 'Version',
			component: Version,
		},
	]
})
